// src/App.jsx
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';

import Topbar             from './components/layout/Topbar';
import ProtectedRoute     from './components/auth/ProtectedRoute';
import TalentRoute        from './components/auth/TalentRoute';
import CollaboratorRoute  from './components/auth/CollaboratorRoute';

import Landing            from './pages/Landing';
import Opportunities      from './pages/Opportunities';
import OpportunityDetail  from './pages/OpportunityDetail';
import Dashboard          from './pages/Dashboard';
import CVOptimizer        from './pages/CVOptimizer';
import Wallet             from './pages/Wallet';
import Training           from './pages/Training';
import Referral           from './pages/Referral';
import CollaboratorPortal from './pages/CollaboratorPortal';
import CollaboratorGate   from './pages/CollaboratorGate';
import AdminPortal        from './pages/admin/AdminPortal';
import NotFound           from './pages/NotFound';

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 1000 * 60 * 5, retry: 1 } },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <style>{`
          select option { background-color: #0f0f24 !important; color: #ffffff !important; }
          select { color-scheme: dark; }
        `}</style>

        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: '#0f0f24', color: '#fff',
              border: '1px solid rgba(254,52,232,0.2)',
              fontFamily: "'DM Sans', sans-serif", fontSize: '14px',
            },
            success: { iconTheme: { primary: '#00d084', secondary: '#0f0f24' } },
            error:   { iconTheme: { primary: '#ef4444', secondary: '#0f0f24' } },
          }}
        />

        <Routes>
          {/* ── Public ── */}
          <Route path="/"                  element={<><Topbar /><Landing /></>} />
          <Route path="/opportunities"     element={<><Topbar /><Opportunities /></>} />
          <Route path="/opportunities/:id" element={<><Topbar /><OpportunityDetail /></>} />

          {/* /collaborators → gate for guests/talents, portal for collaborators */}
          <Route path="/collaborators" element={<><Topbar /><CollaboratorRoute /></>} />

          {/* ── Any logged-in user ── */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard"    element={<Dashboard />} />
            <Route path="/cv-optimizer" element={<CVOptimizer />} />
            <Route path="/wallet"       element={<Wallet />} />
            <Route path="/referral"     element={<Referral />} />
          </Route>

          {/* ── Talent only (collaborators are blocked) ── */}
          <Route element={<TalentRoute />}>
            <Route path="/training" element={<Training />} />
          </Route>

          {/* ── Admin only (guards itself internally) ── */}
          <Route path="/admin" element={<><Topbar /><AdminPortal /></>} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
